import React from 'react';
// import 'myoneui/dist/css/bootstrap.css';
import './assets/scss/student-dashboard/main.scss';
// import styles from './styles.module.css';
// import reportWebVitals from '../reportWebVitals';
// import { Card } from 'react-myoneui';
import CourseApprenticeshipTabs from './components/student-dashboard/CoursesApprenticeshipTabs';
import ReminderListGroup from './components/student-dashboard/ReminderListGroup';
import LiveClassGroup from './components/student-dashboard/LiveClassGroup';
import CommunityForumTabs from './components/student-dashboard/CommunityForumTabs';
// import EventCalendar from './components/student-dashboard/EventCalendar';
import MyKalendar from "./modules/MyKalendar";
import { getWeeklyEvents } from "./modules/MyKalendar/utils/utils";
import {encode, decode} from 'js-base64';
import { _post } from './constants/config';
import './utils/i18n';
import useLangInit from './hooks/useLangInit';

// export const ExampleComponent = ({ text }) => {
//   return <Card>Hello</Card>
//   // return <div className={styles.test}>Example Component: {text}</div>
// }

export const MyCourseApprenticeshipsList = ({accessToken, uuid, spUid, secret,idp, accountId, timeZone, language, showCourseFirst, hideCourses, hideApprenticeship,apiURL}) => {
  let courseFirst   = (typeof showCourseFirst == 'undefined') ? encode('true') : showCourseFirst;
  let hideApCourse  = (typeof hideApprenticeship == 'undefined') ? encode('false') : hideApprenticeship;
  let HideCourses   = (typeof hideCourses == 'undefined') ? encode('false') : hideCourses;
  let Language      = (typeof language == 'undefined') ? encode('en') : language;
  useLangInit('courseapprenticeship');
  return <CourseApprenticeshipTabs accessToken={decode(accessToken)} uuid={decode(uuid)} spUid={decode(spUid)} secret={decode(secret).replace(/[\r\n]/gm, '')} idp={decode(idp)} accountId={decode(accountId)} timeZone={decode(timeZone)} showCourseFirst={decode(courseFirst)} hideCourses={decode(HideCourses)} hideApprenticeship={decode(hideApCourse)} language={decode(Language)} apiURL={apiURL} />
}

export const MyLiveClassGroup = ({accessToken, uuid, spUid, secret, idp, accountId, timeZone, language, allowedProducts}) => {
  let Language = (typeof language == 'undefined') ? encode('en') : language;
  useLangInit('livelist');
  return <LiveClassGroup accessToken={decode(accessToken)} uuid={decode(uuid)} spUid={decode(spUid)} secret={decode(secret).replace(/[\r\n]/gm, '')} idp={decode(idp)} accountId={decode(accountId)} timeZone={decode(timeZone)} language={decode(Language)} allowedProducts={allowedProducts}/>
}

export const MyReminderListGroup = ({accessToken,uuid,spUid,secret,idp,accountId, timeZone, language}) => {
  let Language = (typeof language == 'undefined') ? encode('en') : language; 
  useLangInit('reminders');
  return <ReminderListGroup accessToken={decode(accessToken)} uuid={decode(uuid)} spUid={decode(spUid)} secret={decode(secret).replace(/[\r\n]/gm, '')} idp={decode(idp)} accountId={decode(accountId)} timeZone={decode(timeZone)} language={decode(Language)} />
}

export const MyCommunityForm = ({accessToken, userId, uuid, Authorization, organisationdomain, timeZone, language, newsServiceData}) => {
  let Language = (typeof language == 'undefined') ? encode('en') : language;
  return <CommunityForumTabs accessToken={decode(accessToken)} userId={decode(userId)} uuid={decode(uuid)} Authorization={decode(Authorization)} organisationdomain={decode(organisationdomain)} timeZone={decode(timeZone)} language={decode(Language)} newsServiceData={decode(newsServiceData)} />
}

export const MyEventCalendar = ({accessToken, uuid, accountId, idp, timeZone, language, calendarMode, className}) => {
  let calendarKey = decode(uuid);
  let Language = (typeof language == 'undefined') ? encode('en') : language;
  useLangInit('learnercalendar'); 
  return <MyKalendar  mode={calendarMode} date='' accessToken={decode(accessToken)} uuid={decode(uuid)} accountId={decode(accountId)} idp={decode(idp)} eventListCallback={getWeeklyEvents} calenderKey={calendarKey} timeZone={decode(timeZone)} language={decode(Language)} className={className}/>
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
